import React, { Fragment, useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import moment from "moment";
import {
  Container,
  Col,
  Row,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  Button,
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";

import Widget from "../../components/Widget/Widget.js";
import CustomOnlyModal from "../../components/CustomModal/CustomOnlyModal";
import AddMaintenanceMessageSidebar from "./components/AddMaintenanceMessageSidebar";

import {
  fetchMaintenanceMessages,
  selectMaintenanceMessage,
  updateMaintenanceMessage,
  addMaintenanceMessage,
  removeMaintenanceMessage,
} from "../../actions/maintenances.js";

import s from "./Tables.module.scss";

const Maintenances = function () {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.messages);

  const [addSidebarOpen, setAddSidebarOpen] = useState(false);
  const [secondTableCurrentPage, setSecondTableCurrentPage] = useState(0);
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState({});

  const toggle = () => setModal(!modal);

  useEffect(() => {
    dispatch(fetchMaintenanceMessages());
  }, [dispatch]);

  const refetchMaintenanceMessages = () => {
    dispatch(fetchMaintenanceMessages());
  };

  const pageSize = 10;
  const secondTablePagesCount = Math.ceil(store.messages.length / pageSize);

  const setSecondTablePage = (e, index) => {
    e.preventDefault();
    setSecondTableCurrentPage(index);
  };

  const handleAddFacility = () => {
    setAddSidebarOpen(!addSidebarOpen);
  };

  const messageSelected = (id) => {
    const selectedFacility = store.messages.filter(
      (message) => message.id === id
    )[0];
    dispatch(selectMaintenanceMessage(selectedFacility));
    handleAddFacility();
  };

  const getMessageDetails = async (id) => {
    const response = await axios.get("/facility_maintenances/" + id);
    if (response.status === 200) {
      console.log(response.data, "response.data");
      setModalData({
        ...response.data.messages[0],
      });
    }
    toggle();
  };

  return (
    <Fragment>
      <div>
        <Row>
          <Col>
            <Row className="mb-4">
              <Col>
                <Widget>
                  <div className={s.tableTitle}>
                    <div className="headline-2">Facility Maintenances</div>
                    <div className="d-flex">
                      <Button
                        className="btn-rounded"
                        color="secondary-red"
                        onClick={handleAddFacility}
                      >
                        <span className="align-middle">Add</span>
                      </Button>
                    </div>
                  </div>
                  <div className="widget-table-overflow">
                    <Table
                      className="table-striped table-borderless table-hover"
                      responsive
                    >
                      <thead>
                        <tr>
                          <th>Facility Name</th>
                          <th className={s.nameCol}>Note</th>
                          <th>Scheduled Date</th>
                          <th>Assigned To</th>
                          <th>Status</th>
                          <th>Message</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {store.messages
                          .slice(
                            secondTableCurrentPage * pageSize,
                            (secondTableCurrentPage + 1) * pageSize
                          )
                          .map((item) => (
                            <tr key={uuidv4()}>
                              <td>{item.facility_name}</td>
                              <td>{item.note}</td>
                              <td>
                                {item.maintenance_date
                                  ? moment(item.maintenance_date).format(
                                      "DD/MM/YYYY"
                                    )
                                  : ""}
                              </td>
                              <td>{item.assignedTo}</td>
                              <td>
                                {item.maintenance_type === 'monthly'
                                  ? item.charge_discharge_status || '-'
                                  : item.maintenance_type === 'quarterly'
                                  ? item.notification_status || '-'
                                  : '-'}
                              </td>
                              <td>
                                {item.maintenance_type === 'monthly'
                                  ? item.charge_discharge_message || '-'
                                  : '-'}
                              </td>
                              <td>
                                <div className={`d-flex justify-content`}>
                                  <Button
                                    className="btn-rounded mr-4 mb-3"
                                    color="info"
                                    size="xs"
                                    onClick={() => getMessageDetails(item.id)}
                                  >
                                    View
                                  </Button>
                                  <Button
                                    className="btn-rounded mr-4 mb-3"
                                    color="success"
                                    size="xs"
                                    onClick={() => messageSelected(item.id)}
                                  >
                                    Edit
                                  </Button>
                                  <Button
                                    className="btn-rounded mr-4 mb-3"
                                    color="danger"
                                    size="xs"
                                    onClick={() =>
                                      dispatch(
                                        removeMaintenanceMessage(item.id)
                                      )
                                    }
                                  >
                                    Delete
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                    <Pagination className="pagination-with-border">
                      <PaginationItem disabled={secondTableCurrentPage <= 0}>
                        <PaginationLink
                          onClick={(e) =>
                            setSecondTablePage(e, secondTableCurrentPage - 1)
                          }
                          previous
                          href="#top"
                        />
                      </PaginationItem>
                      {[...Array(secondTablePagesCount)].map((page, i) => (
                        <PaginationItem
                          active={i === secondTableCurrentPage}
                          key={i}
                        >
                          <PaginationLink
                            onClick={(e) => setSecondTablePage(e, i)}
                            href="#top"
                          >
                            {i + 1}
                          </PaginationLink>
                        </PaginationItem>
                      ))}
                      <PaginationItem
                        disabled={
                          secondTableCurrentPage >= secondTablePagesCount - 1
                        }
                      >
                        <PaginationLink
                          onClick={(e) =>
                            setSecondTablePage(e, secondTableCurrentPage + 1)
                          }
                          next
                          href="#top"
                        />
                      </PaginationItem>
                    </Pagination>
                  </div>
                </Widget>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <AddMaintenanceMessageSidebar
        store={store}
        dispatch={dispatch}
        open={addSidebarOpen}
        handleAddMessage={handleAddFacility}
        selectMessage={selectMaintenanceMessage}
        addMessage={addMaintenanceMessage}
        removeMessage={removeMaintenanceMessage}
        refetchMessages={refetchMaintenanceMessages}
        updateMessage={updateMaintenanceMessage}
      />
      <CustomOnlyModal
        modalTitle={`Details for Maintenance Message: ${modalData?.facility_name}`}
        toggle={() => toggle()}
        modalStatus={modal}
      >
        <Container fluid>
          <Row className="mt-sm">
            <Col md={6}>
              <div className={s.column}>Note</div>
            </Col>
            <Col md={6}>
              <div className={s.column}>{modalData?.note}</div>
            </Col>
          </Row>
          <Row className="mt-sm">
            <Col md={6}>
              <div className={s.column}>Assigned Date</div>
            </Col>
            <Col md={6}>
              <div className={s.column}>
                {modalData?.assignedDate ? moment(modalData?.assignedDate).format("DD MMM YYYY") : ''}
              </div>
            </Col>
          </Row>
          <Row className="mt-sm">
            <Col md={6}>
              <div className={s.column}>Status</div>
            </Col>
            <Col md={6}>
              <div className={s.column}>
                {modalData?.maintenance_type === 'monthly'
                  ? modalData?.charge_discharge_status || '-'
                  : modalData?.maintenance_type === 'quarterly'
                  ? modalData?.notification_status || '-'
                  : '-'}
              </div>
            </Col>
          </Row>
          {modalData?.maintenance_type === 'monthly' && (
            <Row className="mt-sm">
              <Col md={6}>
                <div className={s.column}>Message</div>
              </Col>
              <Col md={6}>
                <div className={s.column}>{modalData?.charge_discharge_message || '-'}</div>
              </Col>
            </Row>
          )}
        </Container>
      </CustomOnlyModal>
    </Fragment>
  );
};

export default Maintenances;
